import { render, staticRenderFns } from "./searchScore.vue?vue&type=template&id=beadf2f4&scoped=true&"
import script from "./searchScore.vue?vue&type=script&lang=js&"
export * from "./searchScore.vue?vue&type=script&lang=js&"
import style0 from "./searchScore.vue?vue&type=style&index=0&id=beadf2f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beadf2f4",
  null
  
)

export default component.exports